.fp-vertical-spacing
  .fp-vertical-spacing--line.-align-center
    h2.fp-title {{ t('wallet.guestWallet.title', { name: club.name }) }}
  .fp-vertical-spacing--line.-align-center
    img.fp-illustration.-md.-token
  .fp-vertical-spacing--line.-align-center
    span.fp-text {{ t('wallet.guestWallet.description') }}
  .fp-vertical-spacing--line.-justify-center
    LoginVue(:redirect-to-kyc='true' translate-key='wallet.guestWallet.button')
